export default class FormAnchor {
    static init(): void {
        const anchors: NodeListOf<HTMLAnchorElement> = document.querySelectorAll('a[href="#inteligent-konzultace"]');

        if (anchors.length > 0) {
            anchors.forEach((anchor: HTMLAnchorElement) => {
                anchor.addEventListener('click', (e: MouseEvent) => {
                    e.preventDefault();
    
                    const targetID: string | null = "inteligent-konzultace";
                    if (!targetID) return; // Pokud targetID neexistuje, přerušíme funkci
    
                    const targetElement: HTMLElement | null = document.getElementById(targetID);
                    const navbar: HTMLElement | null = document.querySelector('.navbar');
    
                    if (targetElement && navbar) {
                        const navbarHeight: number = navbar.offsetHeight;
                        // Používáme document.documentElement.scrollTop jako alternativu k window.pageYOffset
                        const targetPosition: number = targetElement.getBoundingClientRect().top + document.documentElement.scrollTop - navbarHeight;
    
                        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
                    }
                });
            });
        }
    }
}